module.exports = __webpack_public_path__ + "img/fintex_log_big.d018e398.png";